import {
    AUTH_USER_DETAILS, EVENT_TRACK
} from './Types';
import axios from "axios/index";
import {API_URL} from "../config/config";
import {getAuthToken, getUserId, getAuthUserDetails} from "./Common";
import {reactLocalStorage} from "reactjs-localstorage";

/**
 * Edit profile
 * @param data
 * @param callback
 * @returns {function(*)}
 */
export function editProfile(data, userId, callback) {
    const authToken = getAuthToken();
    const loginUserId = getUserId();
    const request = axios.put(`${API_URL}/auth/profile/${loginUserId}`, data, {
        headers: {Authorization: `Bearer ${authToken}`}
    });

    return ()=> {
        request.then((data) => {
            callback(data);
        })
        .catch(function (error) {
            callback(error.response);
        });
    }
}

/**
 * Get profile details from local storage
 * @returns {function(*)}
 */
export function getProfileDetailsLocalStorage() {
    const userDetails = getAuthUserDetails();

    return (dispatch)=> {
        dispatch({
            type    : AUTH_USER_DETAILS,
            payload : userDetails
        });
    }
}

/**
 * Get profile details from database
 * @returns {function(*)}
 */
export function getUserProfileDetails(callback) {
    const authToken = getAuthToken();
    const userId = getUserId();
    const request = axios.get(`${API_URL}auth/profile/${userId}`, {
        headers: {Authorization: `Bearer ${authToken}`}
    });

    return (dispatch)=> {
        request.then((res) => {
            callback(res);
            dispatch({
                type    : AUTH_USER_DETAILS,
                payload : res.data
            });
        })
        .catch(function (error) {
            callback(error.response);
        });
    }
}

/**
 * Set contactus data
 * @param data
 * @returns {function(*)}
 */
export function setContactUsData(data, callback) {
  const request = axios.post(`${API_URL}auth/contact`, data);
  return (dispatch)=> {
      request.then((data) => {
          callback(data);
          return true;
      })
      .catch(function (error) {

          callback(error.response);

      });
  }
}

/**
 * Set incentive registration data
 * @param data
 * @returns {function(*)}
 */
export function setIncentiveData(data, callback) {
    const request = axios.post(`${API_URL}auth/incentive`, data);
    return (dispatch)=> {
        request.then((data) => {
            callback(data);
            return true;
        })
        .catch((error) => {
            callback(error.response);
        });
    }
  }

export function eventTracking(data) {
  let userDetail = reactLocalStorage.getObject("user_auth_details");
  const authToken = getAuthToken();
  const request = axios.post(`${API_URL}auth/activity/${userDetail.userId}`, data, {
    headers: {Authorization: `Bearer ${authToken}`}
  })
  return (dispatch)=> {
    request.then((data) => {
        return true;
    })
    .catch(function (error) {
    });
};
}

export function tracking(data, callback) {
  alert("how");
}



// WEBPACK FOOTER //
// ./actions/UserAction.js